module.exports = __webpack_public_path__ + "static/media/mandai-back.683dd665.png";